import { defineStore } from 'pinia';
import type { ErrorItem } from '@/components/Types';

export const useAppStore = defineStore('app', {
  state: () => ({
    drawer: true,
    loading: false,
    currentPage: 1,
    currentTrack: 0,
    openTrack: 0,
    openDestination: [],
    currentSearch: '',
    fileName: '',
    file: '',
    files: [],
    serverRoot: '',
    alertItems: [] as ErrorItem[],
    alertCount: 0
  }),

  getters: {
    getAlertItems(): ErrorItem[] {
      return this.alertItems
    },
    fileLength(): number {
      return this.files.length;
    },
    getServerRoot(): string {
      console.log(window.location.origin)
      if (window.location.origin.includes('localhost')) {
        return 'http://192.168.86.11/pdf/';
      } else {
        return 'https://data.tdot.men/pdf/';
      }
    }
  },
  actions: {
    setSearch(term: string) {
      this.currentSearch = term
    },
    saveFiles(files: never[]) {
      this.files = files;
    },
    setTrack(value: number) {
      this.currentTrack = value;
    },
    setPage(value: number) {
      this.currentPage = value;
    },
    resetFile() {
      this.fileName = "";
      this.file = "";
    },
    showIndexedOnly() {
      const results = this.files.filter(f => JSON.parse(JSON.stringify(f)).songs.length > 0);
      return results;
    },
    find(value: string) {
      const query = value.toLowerCase().replace(/\s+/g, '');
      const results = this.files.filter(f => (JSON.stringify(f).toLowerCase().replace(/\s+/g, '').includes(query)));

      return results;

    },
    setAlert(value: ErrorItem) {
      value.id = this.alertCount++
      value.time = new Date()
      this.alertItems.push(value)
    }
  }
})
